// @flow

export const BID_STATE = {
  WINNING: 0,
  OUTBID: 1
}

export const BIDDING_SET = {
  WINNING: 'winning',
  OUTBID: 'outbid',
  WON: 'won',
  LOST: 'lost'
}

export const CREATE_BID_REQUEST = 'CREATE_BID_REQUEST'
export const CREATE_BID_SUCCESS = 'CREATE_BID_SUCCESS'
export const CREATE_BID_FAILED = 'CREATE_BID_FAILED'

export const CLEAR_BIDS = 'CLEAR_BIDS'
export const CLEAR_BIDS_FOR_AUCTION = 'CLEAR_BIDS_FOR_AUCTION'

export const MIN_BID_INCREMENT_PERCENTAGE = 0.1
export const LIMIT_MIN_BID_INCREMENT_AMOUNT = 100



// WEBPACK FOOTER //
// ./src/services/bid/constants.js